import { GenericErrorBoundary, LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'
import React from 'react'

import { ReconciliationMain } from '../reconciliation-main/reconciliation-main'

export const ReconciliationWrapper = () => (
  <GenericErrorBoundary>
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={<ReconciliationMain />}
      topBarElement={<UserMenuTopBar />}
    />
  </GenericErrorBoundary>
)
